// @flow
import { notes as customerNotes } from './customer';
// types
import type { User } from './user';
import type { Customer } from './customer';

export type ProductNote = {
  // author_id: string,
  // product_name: string,
  /* 💁 while the above props do exist, we aren't using them in scramble-com yet */

  id: string,
  catalogKey: string,
  productNumber: string,
  text: string,
  customerNumber: ?string,
  variationCode: ?string,
};

export type SerializedProductNote = {
  _id: string,
  catalog_key: string,
  product_number: string,
  text: string,
  customer_number: ?string,
  variation_code: ?string,
};

export const userNotes = (notes: ProductNote[]): ProductNote[] =>
  notes.filter((n) => n.customerNumber === null);

export const productNotesGivenUserAndCustomer = (
  user: User,
  customer: Customer | null,
  notes: ProductNote[],
): ProductNote[] =>
  user.type === 'rep'
    ? [
        ...userNotes(notes),
        ...(customer ? customerNotes(customer.number, notes) : []),
      ]
    : notes.filter((n) => n.customerNumber === null);

export const variationNote = (
  notes: ProductNote[],
  variationCode: string | null,
): ProductNote | null =>
  notes.find((n) => n.variationCode === variationCode) || null;

export const styleNote = (notes: ProductNote[]): ProductNote | null =>
  variationNote(notes, null);

/* 🤔I tried using named capture groups like 👇by installing
     '@babel/plugin-transform-named-capturing-groups-regex'
     and upgrading all babel dependencies but had no luck 😭

 const regex = /product_number=(?<productNumber>.*)&catalog_key=(?<catalogKey>.*)/;
    👉 was failing to compile with error `ReferenceError: Unknown helper wrapRegExp`
*/
/* ⚠️ todo write some tests for this */
const regex = /product_number=([^&]*)&catalog_key=([^&]*)/;

export const keyGivenResourceId = (resourceId: string): string => {
  const [
    // eslint-disable-next-line no-unused-vars
    _match,
    productNumber,
    catalogKey,
  ] = resourceId.match(regex) || [null, 'NO_PRODUCT_NUMBER', 'NO_CATALOG_KEY'];
  return `${catalogKey}_${productNumber}`;
};

export const serialized = (
  note: $Shape<ProductNote>,
): $Shape<SerializedProductNote> => ({
  _id: note.id,
  product_number: note.productNumber,
  text: note.text,
  customer_number: note.customerNumber,
  variation_code: note.variationCode,
  catalog_key: note.catalogKey,
});

export const deserialized = (
  note: $Shape<SerializedProductNote>,
): $Shape<ProductNote> => ({
  // eslint-disable-next-line no-underscore-dangle
  id: note._id,
  productNumber: note.product_number,
  text: note.text,
  customerNumber: note.customer_number,
  variationCode: note.variation_code,
  catalogKey: note.catalog_key,
});
